module.exports = __webpack_public_path__ + "static/media/csr_5_komunitas_taufan.577da57d.jpg";